// Widget side: the browser tag list. Loads ONLY through CONSENT1's runTags gate (src/consent.ts).
import { runTags, loadScript, type Choice, type Tag } from "../consent.ts";
import type { Event } from "./payload.ts";

export interface AdIds { meta_pixel_id?: string; google_measurement_id?: string; tiktok_pixel_id?: string }

/** Tag list: each src is an engine-served script (GET /pixel/<platform>.js) that inits the platform and fires `event` with `eventId`. */
export function pixelTags(ads: AdIds, event: Event, eventId: string): Tag[] {
  const q = (id: string) => `?id=${encodeURIComponent(id)}&ev=${event}&eid=${encodeURIComponent(eventId)}`;
  const tags: Tag[] = [];
  if (ads.meta_pixel_id) tags.push({ name: "meta", src: `/pixel/meta.js${q(ads.meta_pixel_id)}` });
  if (ads.google_measurement_id) tags.push({ name: "google", src: `/pixel/google.js${q(ads.google_measurement_id)}` });
  if (ads.tiktok_pixel_id) tags.push({ name: "tiktok", src: `/pixel/tiktok.js${q(ads.tiktok_pixel_id)}` });
  return tags;
}

export const cookie = (name: string): string | undefined =>
  document.cookie.split("; ").find((c) => c.startsWith(name + "="))?.slice(name.length + 1);

/** Fire the browser event for a visit. Gate is runTags: no Accept (or GPC) = nothing loads. */
export async function fireBrowserEvent(apiBase: string, visitId: string, event: Event, consent: Choice | undefined): Promise<string[]> {
  if (consent !== "accepted") return [];
  try {
    const r = await fetch(`${apiBase}/api/visit/${visitId}/ads?event=${event}`);
    if (!r.ok) return [];
    const d = await r.json() as { ads: AdIds; event_id: string };
    return runTags(pixelTags(d.ads, event, d.event_id), consent, (t) => loadScript(t, apiBase));
  } catch { return []; }
}
